export default "__VITE_ASSET__vvIquhlM__"